import React, { useState } from 'react';
import Female from '../../../assets/images/female.png'
import Male from '../../../assets/images/male.png'

import './index.less';

// 性别题
export default function Sex(props) {
    console.log('Sex: ', props);

    const [option, setOption] = useState(0);

    // 点击选项
    const onOptionClick = (index) => () => {
        setOption(index);
    };
    
    return (
        <div className="sex">
            <div className="q-title">
                <div className="q-title-code">
                    gender
                </div>
                <div className="q-title-text">
                    【性别题】
                </div>
            </div>
            <div className="q-content">
                <div className="q-content-options">
                    <div className={`q-content-option ${option === 0 ? 'q-content-option-selected' : ''}`} onClick={onOptionClick(0)}>
                        <div className="option-text">男</div>
                        <img className="option-img" src={Male} alt="" />
                    </div>
                    <div className={`q-content-option ${option === 1 ? 'q-content-option-selected' : ''}`} onClick={onOptionClick(1)}>
                        <div className="option-text">女</div>
                        <img className="option-img" src={Female} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}